import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
  message,
  Button,
} from "antd";
import R2Footer from "../../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MenuSetting from '../../../services/menuSetting';
import PaymentSettings from "./childrens/paymentSetting";
import BusModeSettings from "./childrens/busModeSettings";
import "./style.scss";

const { Content } = Layout;

const PosSetting = (props) => {
  const defaultSetting = {
    "pos_bus_time_mins": 0,
    "pos_allow_bus_time": false,
    "pos_allow_cash_payment":false,
    "pos_allow_tipping_in_terminal":false,
    "pos_allow_tips_for_parties":false,
    "pos_tips_for_parties_greater_than":0,
    "pos_tips_for_parties_amount": 0
  };
  const [settingsList, setSettingsList ] = useState(defaultSetting);
  useEffect(()=>{
    MenuSetting.getRestaurentSettings(props.adminRestaurant).then((res)=>{
        if(res?.restaurant_id){
            setSettingsList(res);
        } else{
          setSettingsList(defaultSetting);
        }
    });
}, [props.adminRestaurant]);
const onUpdateValue = (e, field) => {
  const curentSettings = {...settingsList};
  curentSettings[field] = e;
  setSettingsList(curentSettings);
};
const isUpdateAllowValue = (e, field) => {
  const curentSettings = {...settingsList};
  curentSettings[field] = e.target.value;
  setSettingsList(curentSettings);
};
const onSaveSettings = () => {
  const currentList = {... settingsList};
  delete currentList.created_at;
  delete currentList.id;
  delete currentList.updated_at;
  delete currentList.restaurant_id;
  currentList.est_prep_mins_for_delivery = currentList.est_prep_mins_for_delivery ?? 0;
  currentList.est_prep_mins_for_takeout = currentList.est_prep_mins_for_takeout ?? 0;
  MenuSetting.saveRestaurentSettings(currentList).then((res)=>{
      if(res){
          message.success('Successfully updated the changes');
      }

  });
};
  return (
    <Layout className="u-page-layout pos-layout">
      <Content className="page-padding">
        <Space direction="vertical" style={{width: "100%" }}>
          <PageHeader title="POS Settings" style={{ background: "#f0f2f5" }} />
          <div className="pos-setup">
            <BusModeSettings onUpdateValue={onUpdateValue} settingsList={settingsList} isUpdateAllowValue={isUpdateAllowValue} />
            <PaymentSettings onUpdateValue={onUpdateValue} settingsList={settingsList} isUpdateAllowValue={isUpdateAllowValue} />
            <Button type="primary" className='field_save_btn' 
              style={{ width:"180px", height: "35px", marginBottom: "10px", marginTop: 10 }} 
              onClick={onSaveSettings}> Save </Button>
          </div>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(PosSetting));
